import { createContext, useContext } from 'react';
export var PlaybackContext = /*#__PURE__*/createContext(undefined);
export var usePlaybackContext = function usePlaybackContext() {
  var context = useContext(PlaybackContext);
  if (context === undefined) {
    throw new Error('usePlaybackContext must be used within a PlaybackProvider');
  }
  return context;
};